<div class="progress-bar-container" [class.clickable]="action" [matTooltip]="getTooltip()"
    [matTooltipDisabled]="!isTooltipEnabled()" [title]="''" [style.width]="width" (click)="onClick($event)">
    <div class="progress-bar" [style.width.%]="percentage" [style.backgroundColor]="barColor"></div>
    @if (label) {
    <span class="progress-text" [title]="''">{{ label }}</span>
    } @else {
    <span class="progress-text" [title]="''">{{ percentage | number: '1.0-0' }}%</span>
    }
</div>